import axios from "axios";
import { GET_QUALIFICATION_CONFIG_BY_FORMID } from "./types";
const keys = require("../config/keys");

export const getQualificationConfigurationByFormId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetQualificationConfigurationByFormId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_QUALIFICATION_CONFIG_BY_FORMID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getQualificationConfigurationByFormId.js